import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import reportWebVitals from "./reportWebVitals";
import {ThemeProvider} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import App from "./App"; // default theme
// import {BrowserRouter} from "react-router-dom";
import history from "./history.service"
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { FeatureFlagsProvider } from "./contexts/FeatureFlags"
import { Amplify } from "aws-amplify";
import { setConfig, getAmplifyConfig } from "./nhd-config";

setConfig(JSON.parse(document.getElementById("nhd-config").textContent));
Amplify.configure(getAmplifyConfig());

const root = document.getElementById("root");

Modal.setAppElement(root);

// These flags opt in to new React Router behaviour, and can be removed after updating to v7.
const futureFlags = {
  v7_relativeSplatPath: true,
  v7_startTransition: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_partialHydration: true,
  v7_skipActionErrorRevalidation: true,
};

ReactDOM.render(
  <React.StrictMode>
    <FeatureFlagsProvider>
      <ThemeProvider>
        <HistoryRouter history={history} future={futureFlags}>
          <App />
        </HistoryRouter>
      </ThemeProvider>
    </FeatureFlagsProvider>
  </React.StrictMode>,
  root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
